import React from 'react'
import { Button } from 'antd'
import { Icon } from '@iconify/react'

import styles from './HeaderPrimaryButton.module.css'

const HeaderPrimaryButton = ({
    children,
    onClick,
    disabled = false,
    loading = false,
    icon = <Icon icon="mdi:plus" width={18} />,
    className = '',
}) => (
    <Button
        type="primary"
        icon={icon}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        className={`${styles.button} ${className}`.trim()}
    >
        {children}
    </Button>
)

export default HeaderPrimaryButton
